<button mat-icon-button class="menum-btn d-block d-md-none">
    <mat-icon>menu</mat-icon>
</button>
<mat-nav-list class="sidebar">

    <mat-list-item *ngFor="let item of menu" (click)="itemTitle(item)" [class.d-none]="!item.type" [class.active]="item.activeClass">
        <img src="{{item.icon}}" *ngIf="item.type">
        <a *ngIf="item.type">{{item.title}}</a>
        <mat-nav-list class="submenu sidebr-sidemenu" *ngIf="item.type" [class.d-block]="item.isShow">
            <div class="d-flex justify-content-between align-items-center heading-close">
                <h3 class="mb-0">{{item.title}}</h3>
                <button mat-icon-button (click)="closeBar(item)">
                    <mat-icon>clear</mat-icon>
                </button>
            </div>

            <div class="sidebar-children">
                <div class="insbox" *ngFor="let child of item.children"  [class.d-none]="!child.type">
                    <ng-container *ngIf="child.type && !child.children?.length">
                        <mat-list-item (click)="closeBar(item)" *ngIf="child.type">
                            <ng-container>
                                <a (click)="chooseRoute(child, item)">{{child.title}}</a>
                            </ng-container>
                        </mat-list-item>
                    </ng-container>
                     <ng-container *ngIf="child.type && child.children?.length">
                        <h4>{{child.title}}</h4>
                        <ng-container *ngFor="let inchild of child.children">
                            <mat-list-item (click)="closeBar(item)" *ngIf="inchild.type">
                                <ng-container>
                                    <a (click)="chooseRoute(inchild, item)">{{inchild.title}}</a>
                                </ng-container>
                            </mat-list-item>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
        </mat-nav-list>
    </mat-list-item>
</mat-nav-list>
<!-- Overlay Mobile -->
<div class="overlaym-all"></div>
